import Task from './Task';
import { createError } from '../error';
import EventProduct from '../model/EventProduct';

class EventProductDataSaveTask extends Task {
  constructor($q, APIService, LogService, EventProductService) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
    this.EventProductService = EventProductService;
    this._eventsId = null;
    this._serializedProducts = null;
  }

  get canExecute() {
    return this.APIService.isOnline;
  }

  get updatingObjectTypesAndIds() {
    const updating = [];
    if (this._eventsId) {
      updating.push(['EventProductData', this._eventsId]);
    }
    return updating;
  }

  /**
   * Set the event products data to save.
   *
   * @param {number} eventsId
   * @param {EventProduct[]} eventProducts
   */
  setData(eventsId, eventProducts) {
    this._eventsId = eventsId;
    this._serializedProducts = eventProducts.map(p => ({
      brands_id: p.brands_id,
      product_labels_id: p.product_labels_id,
      data: p.serializeData(),
      issue: p.serializeIssue(),
    }));
  }

  serialize() {
    return {
      eventsId: this._eventsId,
      serializedProducts: this._serializedProducts,
      ...super.serialize(),
    };
  }

  populate(data) {
    this._eventsId = data.eventsId;
    this._serializedProducts = data.serializedProducts;
  }

  execute() {
    if (!this._eventsId || !this._serializedProducts) {
      return this.$q.reject(createError({
        error: 'MissingEventProductData',
        message: 'No event product data to save',
      }));
    }

    // Reconstruct the payload format the API expects
    const payload = { products: {}, issues: {} };
    this._serializedProducts.forEach(item => {
      const key = `${item.brands_id}_${item.product_labels_id || ''}`;
      payload.products[key] = item.data;
      payload.issues[key] = item.issue;
    });

    const path = `/event/${this._eventsId}/products`;
    return this.APIService.post(path, payload)
      .then(response => {
        this.LogService.info('EventProductDataSaveTask: saved successfully');
        return response;
      })
      .catch(err => {
        this.LogService.error('EventProductDataSaveTask: error saving:', err);
        return this.$q.reject(createError({
          error: 'ErrorSavingEventProductData',
          message: 'Error saving event product data',
          response: err,
        }));
      });
  }
}

export default EventProductDataSaveTask;
